// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fades-after {
    opacity: 1;
    animation: fades-out-after 15s ease forwards;
}

@keyframes fades-out-after {

    0%,
    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.footer-hex-container::before {
    animation: pulse 1.6s infinite;
}

@keyframes pulse {
    0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1.5);
        opacity: 0;
    }
}

.logoVideo-animate-start {
    animation-name: logo-video-start;
    animation-fill-mode: forwards;
    animation-duration: 4s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
}

.logoVideo-animate-out {
    animation-name: logo-video-out;
    animation-fill-mode: forwards;
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
}

@keyframes logo-video-start {
    0% {
        opacity: 0;
        height: 120%;
    }

    25% {
        opacity: 1;
        height: 120%;
    }

    45% {
        opacity: 1;
        height: 60%;
    }

    60% {
        opacity: 1;
        height: 60%;
    }

    100% {
        opacity: 1;
        height: 60%;
    }
}

@keyframes logo-video-out {
    0% {
        opacity: 1;
        height: 60%;
        transform: translateY(0);
    }

    70% {
        opacity: 1;
        height: 60%;
        transform: translateY(-3em);
    }

    100% {
        opacity: 0;
        height: 35%;
        transform: translateY(-3em);
    }

}

.weare-heading-start {
    animation: weare-heading-start 1s ease-in forwards;
    animation-iteration-count: 1;
    animation-delay: 2s;

}

.weare-heading-out {
    animation: weare-heading-out .8s ease-in forwards;
    animation-iteration-count: 1;
}

.cubes-heading-start {
    animation: cubes-heading-start 1s ease-in forwards;
    animation-iteration-count: 1;
    animation-delay: 2s;
}

.cubes-heading-out {
    animation: cubes-heading-out .8s ease-in forwards;
    animation-iteration-count: 1;
}

@keyframes weare-heading-start {
    0% {
        opacity: 0;
        transform: translate(-0%);
    }

    100% {
        transform: translate(-45%);
        opacity: 1;
    }
}

@keyframes were-heading-out {
    0% {
        opacity: 1;
        transform: translate(-45%);
    }

    100% {
        transform: translate(-0%);
        opacity: 0;
    }
}

@keyframes cubes-heading-start {
    0% {
        opacity: 0;
        transform: translate(-0%);
    }

    100% {
        transform: translate(60%);
        opacity: 1;
    }
}

@keyframes cubes-heading-out {
    0% {
        opacity: 1;
        transform: translate(60%);
    }

    100% {
        transform: translate(-0%);
        opacity: 0;
    }
}

.globe-image-appears {
    animation: globe-image-appears 1s ease-in forwards;
    animation-iteration-count: 1;
    animation-delay: 1.5s;
}

@keyframes globe-image-appears {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.service-card-icon-appears {
    opacity: 0;
    animation: service-card-icon-appears 1s ease-in forwards;
}

@keyframes service-card-icon-appears {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.service-card-icon-disappears {
    opacity: 1;
    animation: service-card-icon-disappears s ease-in forwards;
}

@keyframes service-card-icon-disappears {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

.service-card-bg-appears {
    animation: service-card-appears 1.2s ease-in forwards;
    transform: scaleY(0);
}

@keyframes service-card-appears {
    0% {
        transform: scaleY(0);
    }

    100% {
        transform: scaleY(1);
    }

}

.service-card-bg-disappears {
    animation: service-card-disappears 1.2s ease-in forwards;
    transform: scaleY(1);
}

@keyframes service-card-disappears {
    0% {
        transform: scaleY(1);
    }

    100% {
        transform: scaleY(0);
    }

}

.service-card-text-container-appears {
    opacity: 0;
    animation: service-card-text-container-appears 1s linear forwards;
}

@keyframes service-card-text-container-appears {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.service-card-text-container-disappears {
    opacity: 1;
    animation: service-card-text-container-disappears 1s linear forwards;
}

@keyframes service-card-text-container-disappears {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

.service-card-icon-1 {
    animation-delay: 0s;
}

.service-card-icon-2 {
    animation-delay: 1s;
}

.service-card-icon-3 {
    animation-delay: 1.5s;
}

.service-card-bg-1 {
    animation-delay: 1s;
}

.service-card-bg-2 {
    animation-delay: 1.5s;
}

.service-card-bg-3 {
    animation-delay: 2s;
}

.service-card-text-container-1 {
    animation-delay: 2s;
}

.service-card-text-container-2 {
    animation-delay: 2.5s;
}

.service-card-text-container-3 {
    animation-delay: 3s;
}


@media screen and (max-width: 768px) {
    @keyframes logo-video-start {
        0% {
          opacity: 0;
          height: 80%;
        }
    
        25% {
          opacity: 1;
          height: 80%;
        }
    
        45% {
          opacity: 1;
          height: 60%;
        }
    
        60% {
          opacity: 1;
          height: 60%;
        }
    
        100% {
          opacity: 1;
          height: 60%;
        }
      }
    
      @keyframes logo-video-out {
        0% {
          opacity: 1;
          height: 80%;
          transform: translateY(0);
        }
        50% {
            opacity: 1;
            height: 40%;
            
        }
    
        80% {
          opacity: 1;
          height: 40%;
        }
    
        100% {
          opacity: 0;
          height: 20%;
          transform: translateY(-4em);
        }
    
      }
}
`, "",{"version":3,"sources":["webpack://./src/styles/animations.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,4CAA4C;AAChD;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,yCAAyC;QACzC,UAAU;IACd;;IAEA;QACI,2CAA2C;QAC3C,UAAU;IACd;AACJ;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,2BAA2B;IAC/B;;AAEJ;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,mBAAmB;;AAEvB;;AAEA;IACI,iDAAiD;IACjD,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,4BAA4B;AAChC;;AAEA;IACI;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;QAC1B,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,wDAAwD;AAC5D;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,0DAA0D;AAC9D;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;AAEJ;;AAEA;IACI,wDAAwD;IACxD,oBAAoB;AACxB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;AAEJ;;AAEA;IACI,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,oEAAoE;AACxE;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI;QACI;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,UAAU;UACV,WAAW;QACb;MACF;;MAEA;QACE;UACE,UAAU;UACV,WAAW;UACX,wBAAwB;QAC1B;QACA;YACI,UAAU;YACV,WAAW;;QAEf;;QAEA;UACE,UAAU;UACV,WAAW;QACb;;QAEA;UACE,UAAU;UACV,WAAW;UACX,2BAA2B;QAC7B;;MAEF;AACN","sourcesContent":[".fades-after {\n    opacity: 1;\n    animation: fades-out-after 15s ease forwards;\n}\n\n@keyframes fades-out-after {\n\n    0%,\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.footer-hex-container::before {\n    animation: pulse 1.6s infinite;\n}\n\n@keyframes pulse {\n    0% {\n        transform: translate(-50%, -50%) scale(1);\n        opacity: 1;\n    }\n\n    100% {\n        transform: translate(-50%, -50%) scale(1.5);\n        opacity: 0;\n    }\n}\n\n.logoVideo-animate-start {\n    animation-name: logo-video-start;\n    animation-fill-mode: forwards;\n    animation-duration: 4s;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in;\n}\n\n.logoVideo-animate-out {\n    animation-name: logo-video-out;\n    animation-fill-mode: forwards;\n    animation-duration: 2s;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in;\n}\n\n@keyframes logo-video-start {\n    0% {\n        opacity: 0;\n        height: 120%;\n    }\n\n    25% {\n        opacity: 1;\n        height: 120%;\n    }\n\n    45% {\n        opacity: 1;\n        height: 60%;\n    }\n\n    60% {\n        opacity: 1;\n        height: 60%;\n    }\n\n    100% {\n        opacity: 1;\n        height: 60%;\n    }\n}\n\n@keyframes logo-video-out {\n    0% {\n        opacity: 1;\n        height: 60%;\n        transform: translateY(0);\n    }\n\n    70% {\n        opacity: 1;\n        height: 60%;\n        transform: translateY(-3em);\n    }\n\n    100% {\n        opacity: 0;\n        height: 35%;\n        transform: translateY(-3em);\n    }\n\n}\n\n.weare-heading-start {\n    animation: weare-heading-start 1s ease-in forwards;\n    animation-iteration-count: 1;\n    animation-delay: 2s;\n\n}\n\n.weare-heading-out {\n    animation: weare-heading-out .8s ease-in forwards;\n    animation-iteration-count: 1;\n}\n\n.cubes-heading-start {\n    animation: cubes-heading-start 1s ease-in forwards;\n    animation-iteration-count: 1;\n    animation-delay: 2s;\n}\n\n.cubes-heading-out {\n    animation: cubes-heading-out .8s ease-in forwards;\n    animation-iteration-count: 1;\n}\n\n@keyframes weare-heading-start {\n    0% {\n        opacity: 0;\n        transform: translate(-0%);\n    }\n\n    100% {\n        transform: translate(-45%);\n        opacity: 1;\n    }\n}\n\n@keyframes were-heading-out {\n    0% {\n        opacity: 1;\n        transform: translate(-45%);\n    }\n\n    100% {\n        transform: translate(-0%);\n        opacity: 0;\n    }\n}\n\n@keyframes cubes-heading-start {\n    0% {\n        opacity: 0;\n        transform: translate(-0%);\n    }\n\n    100% {\n        transform: translate(60%);\n        opacity: 1;\n    }\n}\n\n@keyframes cubes-heading-out {\n    0% {\n        opacity: 1;\n        transform: translate(60%);\n    }\n\n    100% {\n        transform: translate(-0%);\n        opacity: 0;\n    }\n}\n\n.globe-image-appears {\n    animation: globe-image-appears 1s ease-in forwards;\n    animation-iteration-count: 1;\n    animation-delay: 1.5s;\n}\n\n@keyframes globe-image-appears {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.service-card-icon-appears {\n    opacity: 0;\n    animation: service-card-icon-appears 1s ease-in forwards;\n}\n\n@keyframes service-card-icon-appears {\n    0% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n.service-card-icon-disappears {\n    opacity: 1;\n    animation: service-card-icon-disappears s ease-in forwards;\n}\n\n@keyframes service-card-icon-disappears {\n    0% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n}\n\n.service-card-bg-appears {\n    animation: service-card-appears 1.2s ease-in forwards;\n    transform: scaleY(0);\n}\n\n@keyframes service-card-appears {\n    0% {\n        transform: scaleY(0);\n    }\n\n    100% {\n        transform: scaleY(1);\n    }\n\n}\n\n.service-card-bg-disappears {\n    animation: service-card-disappears 1.2s ease-in forwards;\n    transform: scaleY(1);\n}\n\n@keyframes service-card-disappears {\n    0% {\n        transform: scaleY(1);\n    }\n\n    100% {\n        transform: scaleY(0);\n    }\n\n}\n\n.service-card-text-container-appears {\n    opacity: 0;\n    animation: service-card-text-container-appears 1s linear forwards;\n}\n\n@keyframes service-card-text-container-appears {\n    0% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n.service-card-text-container-disappears {\n    opacity: 1;\n    animation: service-card-text-container-disappears 1s linear forwards;\n}\n\n@keyframes service-card-text-container-disappears {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.service-card-icon-1 {\n    animation-delay: 0s;\n}\n\n.service-card-icon-2 {\n    animation-delay: 1s;\n}\n\n.service-card-icon-3 {\n    animation-delay: 1.5s;\n}\n\n.service-card-bg-1 {\n    animation-delay: 1s;\n}\n\n.service-card-bg-2 {\n    animation-delay: 1.5s;\n}\n\n.service-card-bg-3 {\n    animation-delay: 2s;\n}\n\n.service-card-text-container-1 {\n    animation-delay: 2s;\n}\n\n.service-card-text-container-2 {\n    animation-delay: 2.5s;\n}\n\n.service-card-text-container-3 {\n    animation-delay: 3s;\n}\n\n\n@media screen and (max-width: 768px) {\n    @keyframes logo-video-start {\n        0% {\n          opacity: 0;\n          height: 80%;\n        }\n    \n        25% {\n          opacity: 1;\n          height: 80%;\n        }\n    \n        45% {\n          opacity: 1;\n          height: 60%;\n        }\n    \n        60% {\n          opacity: 1;\n          height: 60%;\n        }\n    \n        100% {\n          opacity: 1;\n          height: 60%;\n        }\n      }\n    \n      @keyframes logo-video-out {\n        0% {\n          opacity: 1;\n          height: 80%;\n          transform: translateY(0);\n        }\n        50% {\n            opacity: 1;\n            height: 40%;\n            \n        }\n    \n        80% {\n          opacity: 1;\n          height: 40%;\n        }\n    \n        100% {\n          opacity: 0;\n          height: 20%;\n          transform: translateY(-4em);\n        }\n    \n      }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
